import { Input, Label, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';

function SeccionResidencia({
  formik,
  country,
  province,
  poblationFiltered,
  cpFiltered,
  handleProvinceChange,
  handlePoblationChange,
}) {
  return (
    <Row className="mt-2">
      <Col md="2">
        <Label htmlFor="pais">
          <small>
            País de residencia <span className="text-danger">*</span>
          </small>
        </Label>
        <Input
          id="pais"
          name="pais"
          type="select"
          onChange={formik.handleChange}
          value={formik.values.pais}
          className={formik.errors.pais ? 'border border-danger error' : ''}
        >
          {country !== ''
            ? country.map((option) => (
                <option key={option.idcodi_pais} value={option.nom}>
                  {option.nom}
                </option>
              ))
            : ''}
        </Input>
        {formik.errors.pais ? (
          <div className="text-danger tiny">{formik.errors.pais}</div>
        ) : null}
      </Col>
      <Col md="2">
        <Label htmlFor="provincia">
          <small>
            Provincia de residencia{' '}
            {formik.values.pais !== 'España' ? '' : <span className="text-danger">*</span>}
          </small>
        </Label>
        <Input
          id="provincia"
          name="provincia"
          type="select"
          disabled={formik.values.pais !== 'España'}
          onChange={handleProvinceChange}
          value={formik.values.provincia}
          className={formik.errors.provincia ? 'border border-danger error' : ''}
        >
          {province !== ''
            ? province.map((option) => (
                <option key={option.provincia} value={option.provincia}>
                  {option.provincia}
                </option>
              ))
            : ''}
        </Input>
        {formik.errors.provincia ? (
          <div className="text-danger tiny">{formik.errors.provincia}</div>
        ) : null}
      </Col>
      <Col md="3">
        <Label htmlFor="municipio">
          <small>
            Municipio de residencia{' '}
            {formik.values.pais !== 'España' ? '' : <span className="text-danger">*</span>}
          </small>
        </Label>
        <Input
          id="municipio"
          name="municipio"
          type="select"
          disabled={formik.values.pais !== 'España'}
          onChange={handlePoblationChange}
          value={formik.values.municipio}
          className={formik.errors.municipio ? 'border border-danger error' : ''}
        >
          {poblationFiltered !== ''
            ? poblationFiltered.map((option) => (
                <option key={option.nom_municipi} value={option.nom_municipi}>
                  {option.nom_municipi}
                </option>
              ))
            : ''}
        </Input>
        {formik.errors.municipio ? (
          <div className="text-danger tiny">{formik.errors.municipio}</div>
        ) : null}
      </Col>
      <Col md="2">
        <Label htmlFor="cp">
          <small>
            Código postal{' '}
            {formik.values.pais !== 'España' ? '' : <span className="text-danger">*</span>}
          </small>
        </Label>
        <Input
          id="cp"
          name="cp"
          type="select"
          disabled={formik.values.pais !== 'España'}
          onChange={formik.handleChange}
          value={formik.values.cp}
          className={formik.errors.cp ? 'border border-danger error' : ''}
        >
          {cpFiltered !== ''
            ? cpFiltered.map((option) => (
                <option key={`${option.cp}${option.nom_municipi}`} value={option.cp}>
                  {option.cp}
                </option>
              ))
            : ''}
        </Input>
        {formik.errors.cp ? (
          <div className="text-danger tiny">{formik.errors.cp}</div>
        ) : null}
      </Col>
      <Col md="3">
        <Label htmlFor="domicilio">
          <small>
            Domicilio <span className="text-danger">*</span>
          </small>
        </Label>
        <Input
          id="domicilio"
          name="domicilio"
          type="text"
          onChange={formik.handleChange}
          value={formik.values.domicilio}
          className={formik.errors.domicilio ? 'border border-danger error' : ''}
        />
        {formik.errors.domicilio ? (
          <div className="text-danger tiny">{formik.errors.domicilio}</div>
        ) : null}
      </Col>
    </Row>
  );
}

SeccionResidencia.propTypes = {
  formik: PropTypes.object.isRequired,
  country: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
  province: PropTypes.array.isRequired,
  poblationFiltered: PropTypes.array.isRequired,
  cpFiltered: PropTypes.array.isRequired,
  handleProvinceChange: PropTypes.func.isRequired,
  handlePoblationChange: PropTypes.func.isRequired,
};

export default SeccionResidencia;
